






















import Vue from "vue";
import { displayableUserType } from "../utils";
import { UserType } from "../types";

export default Vue.extend({
  props: {
    type: {
      type: String as () => UserType,
      required: true
    },
    selected: {
      type: Boolean,
      required: true
    }
  },

  computed: {
    iconSource(): string {
      return require(`../images/who-are-you--${this.type}.svg`);
    }
  },
  methods: {
    displayableUserType
  }
});
